import ApiRequest    from '../../api/request.js';
import FormValidated from '../../components/Form/FormValidated';
import FormLoader    from '../../components/Form/FormLoader';
import React 		 from 'react';


/**
  *  State:
  *  	@param 	{bool} 		a		Definition
  */
export default class Graphs extends React.Component
{
	// MARK: - Constructor
	constructor(props)
	{
		console.log('Graphs()');
		super(props);
		this.state =
		{
			a: ''
		}
	}

  /**
    * 	Handler
	*	@param  {event} evt 	On change event
	*/
	evtHandler = (evt) =>
	{

	}


	// MARK: - Render
	render()
	{
		console.log('Graphs.render()');
		return (
		<>
			Graphs
		</>
		);
	}
}
